import { useApp } from 'contexts/app';
import { PageContext } from 'pages/CreateQuiz/PageProvider';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Switch, Text } from 'shell/components';

const QuizFeedbackSettingsSection = () => {
    const { t } = useTranslation(['quiz', 'assignment']);
    const { isFeedbackFeatureDisabled } = useApp();
    const { form, setForm, isEditable = true } = useContext(PageContext);

    return (
        <Stack
            component={'section'}
            aria-labelledby={'quiz-feedback-label'}
            sx={(theme) => ({
                border: `1px solid ${theme.palette.ensightful.neutral[300]}`,
                borderRadius: '16px',
                p: 3,
            })}
            spacing={3}
        >
            <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} spacing={3}>
                <Text
                    component={'label'}
                    id={'quiz-feedback-label'}
                    htmlFor={'quiz-feedback-toggle'}
                    variant={'p1'}
                    weight={'medium'}
                >
                    {t('feedback.include', 'Include Quiz Feedback')}
                </Text>
                <Switch
                    sx={{ flexShrink: 0 }}
                    id={'quiz-feedback-toggle'}
                    aria-labelledby={'quiz-feedback-label'}
                    checked={form.aiFeedbackEnabled && !isFeedbackFeatureDisabled}
                    disabled={!isEditable || isFeedbackFeatureDisabled}
                    tooltip={
                        isFeedbackFeatureDisabled
                            ? {
                                  component: t(
                                      'assignment:institution-disabled',
                                      'Disabled by your institution. Request access or contact IT.'
                                  ),
                              }
                            : undefined
                    }
                    onChange={(_, checked) => setForm((current) => ({ ...current, aiFeedbackEnabled: checked }))}
                />
            </Stack>
            <Text sx={{ maxWidth: '600px' }}>
                {t(
                    'feedback.description',
                    'When turned on, TimelyGrader generates question-specific feedback that instructors can share with students to explain the reasoning behind each grade.'
                )}
            </Text>
        </Stack>
    );
};

export default QuizFeedbackSettingsSection;
